// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"
import {MapController} from "./map_controller";
import {FeedbackController} from "./feedback_controller";
import {FeedbackMapController} from "./feedback_map_controller";
import {RefreshController} from "./refresh_controller";
import {I18nController} from "./i18n_controller";

application.register("map", MapController)
application.register("feedback", FeedbackController)
application.register("feedback-map", FeedbackMapController)
application.register("refresh", RefreshController)
application.register("i18n", I18nController)